<!-- begin::Footer -->
<footer class="tw:relative tw:bottom-0 tw:p-2.5 tw:bg-emphasis tw:border tw:border-surface">
  @if (manualRefreshReminderTimeout() > 0) {
    <div class="tw:flex tw:items-center tw:gap-2 tw:sm:absolute tw:left-2.5">
      @if (!isCountDownRecalculating()) {
        <span class="tw:text-muted-color-emphasis">
          You'll be logged out in {{ countDown$ | async }}
        </span>
        <i class="pi pi-spin pi-sync tw:text-muted-color-emphasis"></i>
      }
      @if (isCountDownRecalculating()) {
        <span class="tw:text-muted-color-emphasis">Refreshing...</span>
      }
    </div>
  }
  <div class="tw:flex-1 tw:text-center tw:text-muted-color-emphasis tw:font-semibold">
    <span class="tw:text-muted-color tw:font-normal">Powered By</span>
    <span
      [pTooltip]="
        version.buildDate()
          ? `Date: ${version.buildDate()} | Commit: ${version.commitId()}`
          : `Commit: ${version.commitId()}`
      "
      tooltipPosition="top"
      (dblclick)="copyCommitId()">
      Corridor Platforms
    </span>
  </div>
</footer>
<!-- end::Footer -->
